module.exports = __webpack_public_path__ + "static/media/photo188.4a644cd9.jpg";